import React, { useState } from "react";
import { IdleTimerProvider } from "react-idle-timer";
import IdleTimerPopup from "./IdleTimerPopup";

import { store } from "../../../utils/index";

function IdleTimerContainer() {
    const [timer, setTimer] = useState(false);

    const onIdle = () => {
        if (store.get("userInfo")) {
            setTimer(true);
        }
    };

    return (
        <>
            {timer && (
                <IdleTimerPopup
                    openModal={timer}
                    closeModal={() => setTimer(false)}
                />
            )}
            <IdleTimerProvider
                timeout={30 * 60 * 1000} // 30 minutes
                onIdle={onIdle}
            ></IdleTimerProvider>
        </>
    );
}

export default IdleTimerContainer;
